import DocumentUploadInput from "../../../components/shared/DocumentUploadInput";
import LazySearchSelect from "../../../components/shared/LazySearchSelect";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Textarea } from "../../../components/ui/textarea";

const CostingForm = ({ formData, setFormData, onAddContractor }) => {
  // Get today's date in YYYY-MM-DD format for the min attribute
  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="space-y-4">
      {/* ... previous grid fields ... */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="projectId">
            Project <span className="text-red-500">*</span>
          </Label>
          <LazySearchSelect
            value={formData.projectId || ""}
            onChange={(val) => setFormData({ ...formData, projectId: val })}
            apiUrl="/projects"
            placeholder="Select project"
            searchPlaceholder="Search projects..."
            labelKey="name"
            valueKey="id"
          />
        </div>

        <div>
          <div className="flex items-center justify-between mb-1">
            <Label htmlFor="contractorId">
              Contractor <span className="text-red-500">*</span>
            </Label>
            {!formData.id && onAddContractor && (
              <Button
                type="button"
                variant="link"
                size="sm"
                className="h-auto p-0 text-xs text-primary"
                onClick={onAddContractor}
              >
                + Add New
              </Button>
            )}
          </div>
          <LazySearchSelect
            value={formData.contractorId || ""}
            onChange={(val) => setFormData({ ...formData, contractorId: val })}
            apiUrl="/contractors"
            extraParams={!formData.id ? { excludeWithCosting: true } : {}}
            placeholder="Select contractor"
            searchPlaceholder="Search contractors..."
            labelKey="contractorName"
            valueKey="id"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="costingDate">
            Date <span className="text-red-500">*</span>
          </Label>
          <Input
            id="costingDate"
            type="date"
            value={formData.costingDate ? formData.costingDate.split("T")[0] : ""}
            onChange={(e) => setFormData({ ...formData, costingDate: e.target.value })}
            required
          />
          <p className="text-[10px] text-slate-500 mt-1 italic">Previous dates are disabled</p>
        </div>

        <div>
          <Label htmlFor="estimatedAmount">
            Estimated Amount <span className="text-red-500">*</span>
          </Label>
          <Input
            id="estimatedAmount"
            type="number"
            step="0.01"
            value={formData.estimatedAmount || ""}
            onChange={(e) => setFormData({ ...formData, estimatedAmount: e.target.value })}
            placeholder="0.00"
            required
          />
        </div>
      </div>

      <div>
        <Label htmlFor="consumedAmount">Consumed Amount</Label>
        <Input id="consumedAmount" type="number" step="0.01" value={formData.consumedAmount || "0"} disabled placeholder="0.00" />
      </div>

      <div>
        <Label htmlFor="remarks">Remarks</Label>
        <Textarea
          id="remarks"
          value={formData.remarks || ""}
          onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
          placeholder="Any additional notes or remarks"
          rows={3}
        />
      </div>

      <DocumentUploadInput
        value={formData.documents || []}
        onChange={(val) => setFormData({ ...formData, documents: val })}
        label="Attachments (Optional)"
        multiple={true}
      />
    </div>
  );
};

export default CostingForm;
